import Backbone from 'backbone'
import _ from 'lodash'
import { Vertical as VerticalElementSnap } from './element-position-snap'
import { Horizontal as HorizontalElementSnap } from './element-position-snap'
import { Vertical as VerticalSpacingElementSnap } from './element-spacing-snap'
import { Horizontal as HorizontalSpacingElementSnap } from './element-spacing-snap'
import { Width as WidthElementSnap } from './element-size-snap'
import { Height as HeightElementSnap } from './element-size-snap'
import SnapType from '../snap-type'

var WidgetSnap = SnapType.extend({

  initialize: function (options) {
    this.canvas = options.canvas

    // array of visual guides draw on the canvas
    this.guides = []

    // types of snaps supported by this widget snapper
    this.types = [
                  new VerticalElementSnap(options),
                  new HorizontalElementSnap(options),
                  new HeightElementSnap(options),
                  new WidthElementSnap(options),
                  new VerticalSpacingElementSnap(options),
                  new HorizontalSpacingElementSnap(options)
                 ]
  },

  _snap: function (difference, guides) {
    this.releaseGuides(difference)

    _(guides).groupBy('direction') // Group the guides based on their snapping direction
              .each((guides, direction) => {
                guides.sort((a, b) => Math.abs(a.diff) - Math.abs(b.diff)) // Now sort the guides in this direction based on the `diff` which is the distance they should snap

                let guide = guides[0]

                difference[direction] = guide.diff

                guides.filter(g => g.diff === guide.diff) // Show all other guides that match the current `diff`. Other guides won't be aligned since we're snapping to some new location
                      .forEach(g => this.guides.push(g))
              })

    // Group the guides by their type, then render
    _(this.guides).groupBy('type')
                  .each((guides, type) => {
                    guides.forEach(guide => this.$el.append(guide.render().adjust(guides).el))
                  })
    return difference
  },

  _guides: function (mapper) {
    return [].concat(...this.types.map(mapper))
  },

  snap: function (area, previousArea, handleType) {
    let difference = {}
      , guides = this._guides(type => type.getGuides(area, previousArea, handleType))

    return this._snap(difference, guides)
  },

  releaseGuides: function () {
    this.guides.forEach(guide => guide.release())
    this.guides = []
  },

  release: function () {
    // Don't call `.remove()` b/c it would remove the `el`, which is the canvas.
    this.releaseGuides()
    this.types = []
  }
})

export default WidgetSnap
